import React from 'react';
import { connect } from 'react-redux';
import { Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { selectSource, setActivitySelectedTables } from '../../../actions/synchronisationActions';

function getSourceLabel(source) {
  if (!source) return 'Unknown';
  return source.integrationName || source.sourceType || 'Unknown';
}

function SourceSelector({ sources, currentSourceId, selectSource, setActivitySelectedTables, filter }) {
  let sourceList = Object.values(sources);
  if (typeof filter === 'function') {
    sourceList = sourceList.filter(filter);
  }

  if (sourceList.length <= 1) {
    return null;
  }

  return (
    <div className="mb-3">
      <Nav pills>
        {sourceList.map((source) => (
          <NavItem key={source.id}>
            <NavLink
              className={classnames({ active: source.id === currentSourceId })}
              style={{ cursor: 'pointer' }}
              onClick={() => {
                selectSource(source.id);
                setActivitySelectedTables([]);
              }}
            >
              {getSourceLabel(source)}
            </NavLink>
          </NavItem>
        ))}
      </Nav>
    </div>
  );
}

SourceSelector.propTypes = {
  sources: PropTypes.object,
  currentSourceId: PropTypes.number,
  selectSource: PropTypes.func.isRequired,
  filter: PropTypes.func,
};

export default connect(
  (state) => ({
    sources: state.sync.source.sources,
    currentSourceId: state.sync.source.currentSourceId,
  }),
  (dispatch) => ({
    selectSource: (sourceId) => dispatch(selectSource(sourceId)),
    setActivitySelectedTables: (tables) => dispatch(setActivitySelectedTables(tables)),
  })
)(SourceSelector);
